import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import {
  ControlOptionValue,
  DialogComponentsModule,
  InputSelectComponent,
  InputTextareaComponent,
  WuiButtonModule,
  WuiDialog,
} from 'wflow-ui';
import {
  PeppolRejectReason,
  PeppolRequiredAction,
} from '../../interfaces/peppol-item.dto';

@Component({
  selector: 'wf-peppol-reject-dialog',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ReactiveFormsModule,
    TranslateModule,
    DialogComponentsModule,
    WuiButtonModule,
    InputSelectComponent,
    InputTextareaComponent,
  ],
  templateUrl: './peppol-reject-dialog.component.html',
  styleUrl: './peppol-reject-dialog.component.scss',
  host: { class: 'wf-peppol-reject-dialog' },
})
export class PeppolRejectDialogComponent {
  private readonly dialogRef = inject(WuiDialog);
  private readonly fb = inject(FormBuilder);

  protected readonly reasonOptions = this.buildOptions(
    PeppolRejectReason,
    'PEPPOL.REJECT_REASON',
  );
  protected readonly requiredActionOptions = this.buildOptions(
    PeppolRequiredAction,
    'PEPPOL.REQUIRED_ACTION',
  );

  protected readonly form = this.buildForm(this.fb);

  protected submit(): void {
    this.dialogRef.close(this.form.getRawValue());
  }

  protected cancel(): void {
    this.dialogRef.close();
  }

  private buildForm(fb: FormBuilder) {
    return fb.nonNullable.group({
      reason: [PeppolRejectReason.NoIssue],
      requiredAction: [PeppolRequiredAction.NoActionRequired],
      note: [''],
    });
  }

  private buildOptions(
    enumType: Record<string, string>,
    labelPrefix: string,
  ): ControlOptionValue<string>[] {
    return Object.values(enumType).map((value) => ({
      value,
      label: `${labelPrefix}.${value}`,
    }));
  }
}
